/**
 * Formats a number by adding spaces as thousand separators.
 * @param num - The number to format.
 * @returns The formatted number as a string.
 */
export const formatNumber = (num: number): string => {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
};

export const formatDateRange = (from?: Date, to?: Date): string => {
  if (!to && from) {
    return from.toLocaleDateString();
  }

  if (!from && to) {
    return to.toLocaleDateString();
  }

  if (from && to && from < to) {
    return `${from.toLocaleDateString()} - ${to.toLocaleDateString()}`;
  }

  if (from && to && from.getTime() === to.getTime()) {
    return `${from.toLocaleDateString()}`;
  }
  return "";
};

export const formatNumberRange = (min?: number, max?: number): string => {
  const isNumber = (value: unknown): value is number =>
    typeof value === "number";
  if (!isNumber(max)) {
    return `≥ ${min}`;
  }

  if (!isNumber(min)) {
    return `≤ ${max}`;
  }

  return `[${min} ; ${max}]`;
};
